/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */
import packageJson from '../../package.json';
import {KEYCLOAK_NOT_CONFIGURED} from '../services/authentication/keycloak/keycloak-configuration';
import {resolveApiBaseUrl} from './api-base-url';

const BP_ENV = 'demo';
const BACKEND_BASE_HOST = 'qa.battery-passport.siemens.cloud';
const ALB_BASE_URL = resolveApiBaseUrl(
  import.meta.env?.BP_SAME_ORIGIN_API,
  `https://apps-${BP_ENV}.${BACKEND_BASE_HOST}`,
);

export const environment = {
  production: false,
  environment: BP_ENV,
  version: packageJson.version,
  applicationType: import.meta.env?.BP_APPLICATION_TYPE ?? 'SBP',
  authenticationProvider: 'AUTH0',
  datadog: {
    clientToken: 'pubeeaca4f116fe38bf46abb0119fc7bf76',
    serviceName: 'portal-frontend',
    site: 'datadoghq.eu',
    env: BP_ENV,
  },
  backend: {
    user_host: `${ALB_BASE_URL}/user-management-service`,
    assignment_host: `${ALB_BASE_URL}/assignment-management-service`,
    passport_host: `${ALB_BASE_URL}/passport-management-service`,
    cx_connector_host: `${ALB_BASE_URL}/connector/cx`,
    feature_config_host: `${ALB_BASE_URL}/feature-config-service`,
    ai_query_host: `${ALB_BASE_URL}/ai-query-service`,
    aas_connector_host: `${ALB_BASE_URL}/aas-connector`,
  },
  auth0: {
    mainTenant: 'login-qa.siemens.com',
    domain: 'siemens-qa-00286.siemens-qa.auth0app.com',
    clientId: 'Dv04Xuwe3ryiE1H3hpiXv3SPOEmNmbmG',
    useRefreshTokens: true,
    errorPath: '/error',
    ignoreCache: true,
    authorizationParams: {
      acr_values:
        (import.meta.env?.BP_DISABLE_MFA ?? 'false') === 'true'
          ? 'aal1'
          : 'aal2',
      display: 'sup',
      connection: 'main-tenant-oidc',
      redirect_uri: `${window.location.origin}/app`,
      audience: 'https://my-backend.com',
    },
  },
  /** Keycloak is not available in this environment; the build uses Auth0. */
  keycloak: KEYCLOAK_NOT_CONFIGURED,
  pmd: {
    enable_timeseries: import.meta.env?.BP_ENABLE_AAS_TIMESERIES,
  },
  frontend: {
    enable_ai_query: import.meta.env?.BP_ENABLE_AI_QUERY,
    email_sender_providers: import.meta.env?.BP_EMAIL_SENDER_PROVIDERS,
  },
};
